export const AUDIENCE_LISTS = {
  LOAD: 'AUDIENCE_LISTS_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_LOAD_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_LOAD_FAIL',
  RESET: 'AUDIENCE_LISTS_LOAD_RESET',
  UPDATE_CONTACTS_COUNT: 'UPDATE_CONTACTS_COUNT',
  CHANGE_SEARCH_COUNT: 'CHANGE_SEARCH_COUNT',
  REMOVE_FROM_LIST: 'AUDIENCE_LISTS_REMOVE_FROM_LIST',
  ENABLE_EXPORT_LOADER: 'AUDIENCE_LISTS_ENABLE_EXPORT_LOADER',
  DISABLE_EXPORT_LOADER: 'AUDIENCE_LISTS_DISABLE_EXPORT_LOADER',
  SET_ERROR: 'AUDIENCE_LISTS_SET_ERROR',
  SET_CLOSE: 'AUDIENCE_LISTS_SET_CLOSE',
  SET_OPEN: 'AUDIENCE_LISTS_SET_OPEN',
  NAMES_LOAD: 'AUDIENCE_LISTS_NAMES_LOAD',
  NAMES_LOAD_SUCCESS: 'AUDIENCE_LISTS_NAMES_SUCCESS',
  NAMES_FAIL: 'AUDIENCE_LISTS_NAMES_FAIL',
  NAMES_RESET: 'AUDIENCE_LISTS_NAME_RESET',
  CLONE_LOAD: 'AUDIENCE_LISTS_CLONE_LOAD',
  CLONE_SUCCESS: 'AUDIENCE_LISTS_CLONE_SUCCESS',
  CLONE_FAIL: 'AUDIENCE_LISTS_CLONE_FAIL',
  FILTERS: 'AUDIENCE_LISTS_FILTERS',
  CLONE_SUCCESS_SEARCH: 'AUDIENCE_LISTS_CLONE_SUCCESS_SEARCH',
  REMOVE_FROM_LIST_SEARCH: 'AUDIENCE_LISTS_REMOVE_FROM_LIST_SEARCH',
  RESET_ALREADY_EXIST_ERROR: 'AUDIENCE_LISTS_RESET_ALREADY_EXIST_ERROR',
  IMPORT_LIST_SUCCESS: 'AUDIENCE_LISTS_IMPORT_LIST_SUCCESS',
  TOTAL_CONTACTS_UPDATE: 'AUDIENCE_LISTS_TOTAL_CONTACTS_UPDATE',
  LIST_NAME_UPDATE: 'AUDIENCE_LISTS_LIST_NAME_UPDATE',
  LISTS_RESET: 'AUDIENCE_LISTS_LISTS_RESET',
};

export const AUDIENCE_LISTS_SELECTION = {
  SET: 'AUDIENCE_LISTS_SELECTION_SET',
  RESET: 'AUDIENCE_LISTS_SELECTION_RESET',
};

export const AUDIENCE_LISTS_ADD = {
  LOAD: 'AUDIENCE_LISTS_ADD_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_ADD_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_ADD_FAIL',
  RESET: 'AUDIENCE_LISTS_ADD_RESET',
  RESET_REMOVE_SEARCH: 'AUDINECE_RESET_REMOVE_SEARCH',
  NEWLY_CREATED_LIST_ID: 'AUDINECE_NEWLY_CREATED_LIST_ID',
  NEWLY_CREATED_LIST_CHECK: 'AUDINECE_NEWLY_CREATED_LIST_CHECK',
  DETAILS_SUCCESS_MESSAGE: 'AUDIENCE_LISTS_DETAILS_SUCCESS_MESSAGE',
};

export const AUDIENCE_LISTS_DELETE = {
  LOAD: 'AUDIENCE_LISTS_DELETE_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_DELETE_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_DELETE_FAIL',
  RESET: 'AUDIENCE_LISTS_DELETE_RESET',
};

export const AUDIENCE_LISTS_NAME_EDIT = {
  LOAD: 'AUDIENCE_LISTS_NAME_EDIT_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_NAME_EDIT_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_NAME_EDIT_FAIL',
  RESET: 'AUDIENCE_LISTS_NAME_EDIT_RESET',
  UPDATE_LAST: 'AUDIENCE_LISTS_NAME_UPDATE_LAST',
};

export const AUDIENCE_LISTS_SEARCH = {
  SET_SEARCH: 'AUDIENCE_LISTS_SEARCH_SET_SEARCH',
  LOAD: 'AUDIENCE_LISTS_SEARCH_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_SEARCH_LOAD_SUCCESS',
  ERROR_SEARCH_TERM: 'AUDIENCE_LISTS_SEARCH_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'AUDIENCE_LISTS_SEARCH_ERROR_SEARCH_TERM_LOADING',
  FAIL: 'AUDIENCE_LISTS_SEARCH_LOAD_FAIL',
  RESET: 'AUDIENCE_LISTS_SEARCH_LOAD_RESET',
  REFRESH_SEARCH: 'AUDIENCE_LISTS_REFRESH_SEARCH',
};

export const AUDIENCE_LISTS_DETAILS = {
  LOAD: 'AUDIENCE_LISTS_DETAILS_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_DETAILS_LOAD_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_DETAILS_LOAD_FAIL',
  RESET: 'AUDIENCE_LISTS_DETAILS_LOAD_RESET',
  SET_NAME: 'AUDIENCE_LISTS_DETAILS_SET_NAME',
  SET_RELOAD_LIST: 'AUDIENCE_LISTS_DETAILS_SET_RELOAD_LIST',
  TOTAL_COUNT_UPDATE_ON_DELETE_ALL_LIST: 'AUDIENCE_LISTS_DETAILS_TOTAL_COUNT_UPDATE_ON_DELETE_ALL_LIST',
  ADD_NEW_CONTACT: 'AUDIENCE_LISTS_DETAILS_ADD_NEW_CONTACT',
  ALREADY_EXISTS: 'AUDIENCE_LISTS_DETAILS_ALREADY_EXISTS',
  TOTAL_COUNT_UPDATE_LIST: 'AUDIENCE_LISTS_DETAILS_TOTAL_COUNT_UPDATE_LIST',
  RESET_TOTAL_COUNT: 'AUDIENCE_LISTS_DETAILS_RESET_TOTAL_COUNT',
  SET_SEARCH_TERM: 'AUDIENCE_LISTS_DETAILS_SET_SEARCH_TERM',
  CONTACT_UPDATED_SUCCESS: 'AUDIENCE_LISTS_DETAILS_CONTACT_UPDATED_SUCCESS',
  RESET_CONTACT_UPDATED_SUCCESS: 'AUDIENCE_LISTS_DETAILS_RESET_CONTACT_UPDATED_SUCCESS',
  RESET_NEWLY_ADDED_CONTACT: 'AUDIENCE_LISTS_DETAILS_RESET_NEWLY_ADDED_CONTACT',
  SET_APPLIED_SEARCH: 'AUDIENCE_LISTS_DETAILS_SET_APPLIED_SEARCH',
  SET_CLEAR_SEARCH_TERM: 'AUDIENCE_LISTS_DETAILS_SET_CLEAR_SEARCH_TERM',
  RESET_CONTACTS_ADDED_TO_LIST: 'RESET_CONTACTS_ADDED_TO_LIST',
  CONTACTS_ADDED_TO_LIST: 'CONTACTS_ADDED_TO_LIST',
  CONTACT_FAILED_TO_UPDATE: 'CONTACT_FAILED_TO_UPDATE',
  RESET_CONTACT_FAILED_TO_UPDATE: 'CONTACT_FAILED_TO_UPDATE',
};

export const AUDIENCE_LISTS_NON_PROFILED_CONTACTS = {
  LOAD: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_LOAD_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_LOAD_FAIL',
  RESET: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_LOAD_RESET',
  REMOVE_PROFILED: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_REMOVE_PROFILED',
};

export const AUDIENCE_LISTS_PROFILED_CONTACTS = {
  LOAD: 'AUDIENCE_LISTS_PROFILED_CONTACTS_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_PROFILED_CONTACTS_LOAD_SUCCESS',
  ERROR_SEARCH_TERM: 'AUDIENCE_LISTS_PROFILED_CONTACTS_ERROR_SEARCH_TERM',
  ERROR_SEARCH_TERM_LOADING: 'AUDIENCE_LISTS_PROFILED_CONTACTS_ERROR_SEARCH_TERM_LOADING',
  FAIL: 'AUDIENCE_LISTS_PROFILED_CONTACTS_LOAD_FAIL',
  RESET: 'AUDIENCE_LISTS_PROFILED_CONTACTS_LOAD_RESET',
  REMOVE_NON_PROFILED: 'AUDIENCE_LISTS_PROFILED_CONTACTS_REMOVE_NON_PROFILED',
  SET_FILTERS: 'AUDIENCE_LISTS_PROFILED_CONTACTS_SET_FILTERS',
  SET_SELECTED_FILTERS: 'AUDIENCE_LISTS_PROFILED_CONTACTS_SET_SELECTED_FILTERS',
};

export const AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE = {
  LOAD: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE_LOAD_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE_LOAD_FAIL',
  RESET: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE_LOAD_RESET',
  UNSUBSCRIBE_LIST_SUCCESS: 'AUDIENCE_LISTS_NON_PROFILED_CONTACTS_DELETE_LOAD_UNSUBSCRIBE_LIST_SUCCESS',
};

export const AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE = {
  LOAD: 'AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE_LOAD',
  SUCCESS: 'AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE_LOAD_SUCCESS',
  FAIL: 'AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE_LOAD_FAIL',
  RESET: 'AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE_LOAD_RESET',
  UNSUBSCRIBE_LIST_SUCCESS: 'AUDIENCE_LISTS_PROFILED_CONTACTS_DELETE_LOAD_UNSUBSCRIBE_LIST_SUCCESS',
};

export const AUDIENCE_LISTS_CONTACTS_EDIT = {
  SUCCESS: 'AUDIENCE_LISTS_CONTACTS_EDIT_SUCCESS',
};

export const AUDIENCE_LISTS_BOTH = {
  ADD_TO_EXISTING_LIST: 'ADD_TO_EXISTING_LIST',
  REMOVE_FROM_EXISTING_LIST: 'REMOVE_FROM_EXISTING_LIST',
};
